<template>
  <div>
    <TopNavigation activeApp="Cmdb"/>
    <b-container fluid class="app-nav ml-0">
      <b-row  class="text-right">
        <b-col class="my-1" style="text-align:left">
          <b-form-group
            label="Items/page"
            label-cols="3"
            label-align="left"
            label-size="sm"
            label-for="perPageSelect"
            class="m-0"
          >
            <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
              style="align-items:left;width:25%"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="5" class="my-1" style="text-align:center">
          <b-form-group
            label="Filter"
            label-cols-sm="1"
            label-align-sm="center"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="my-1">
          <b-button 
            size="sm" 
            variant="outline-secondary"
            @click="addNew"
          > Add New Config</b-button>
        </b-col>

      </b-row>
    </b-container>

    <b-table
      stacked="sm"
      ref="configsTable"
      fixed
      show-empty 
      small 
      hover 
      striped 
      bordered 
      :filter="filter"
      @filtered="onFiltered"
      :busy="isBusy"
      :items="items" 
      :fields="fields" 
      :current-page="currentPage"
      :per-page="perPage"
      sticky-header="500px"
      no-border-collapse
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      selectable
      select-mode="single"
      selected-variant="success"
      @row-selected="onConfigSelected"
      style="word-break: break-all"
    >

      <div slot="table-busy" class="text-center text-secondary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
      </div>

    </b-table>

    <CMDBConfig v-if="showItem" :guid="selectedGuid" v-on:cancelled="resetSelected" v-on:updated="configsUpdated" />

    <b-container class="app-nav mr-0">
      <b-row align-h="end">
        <b-col cols="3">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-2"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>


  </div>
</template>

<script>
import TopNavigation from '@/components/TopNavigation.vue'
import CMDBConfig from '@/components/cmdb/Cmdbconfig.vue'
import CMDBService from '@/api-services/cmdb.service'
import { Auth } from 'aws-amplify'


export default {
  name: 'cmdblist',
  components: {
    CMDBConfig,
    TopNavigation
  },
  data() {
    return {
      sortBy: 'linetag',
      sortDesc: false,
      fields: [
        {
          key: 'version',
          label: 'Status',
          sortable: true
        },
        {
          key: 'linetag',
          label: 'Linetag',
          sortable: true
        },
        {
          key: 'vendor_circuit_id',
          label: 'Vendor Circuit ID',
          sortable: true
        },
        {
          key: 'core_router_name',
          label: 'Core Router Name',
          sortable: true,
        },
        {
          key: 'core_router_interface',
          label: 'Core Router Interface',
          sortable: true,
        },
        {
          key: 'remote_router_ip',
          label: 'Remote Router IP',
          sortable: true,
        },
        {
          key: 'wan_ip_range',
          label: 'WAN IP Range',
          sortable: true
        },
      ],
      items:[],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 30, 50],
      filter: null,
      filterOn: [],
      showItem:false,
      selectedItem:[],
      isBusy: false,
      selectedGuid:null,
    }
  },
  mounted() {
      // Set the initial number of items
      this.getAllConfigs()
      this.totalRows = this.items.length
  },
  methods: {
  // async viewCanEnter(){ 
  //       try  { 
  //           await Auth.currentAuthenticatedUser() 
  //           return true 
  //       } 
  //       catch(e) { 
  //           alert("user is not logged in")
  //           return false 
  //       }
  //   },

    onConfigSelected(items) {
      // this.viewCanEnter() //check if the user is still logged in

      if (items.length!=0){ //required as this.$refs.configsTable.clearSelected() triggers @row-selected in order to deselct
        this.selectedGuid = items[0].guid
        this.showItem = true
      }
    },
    resetSelected(){
      this.showItem = false
      this.$refs.configsTable.clearSelected()
      this.selectedGuid = null
    },
    addNew() {
      this.showItem = true
    },
    configsUpdated(){
      this.showItem = false
      this.selectedGuid = null
      this.getAllConfigs()
    },
    getAllConfigs() {
      this.isBusy = true
      let promise = CMDBService.getAllConfigs()
      return promise.then((data) => {
        console.log(data)
        this.items = data.Items
        // Here we could override the busy state, setting isBusy to false
        this.isBusy = false
        this.totalRows = this.items.length
      }).catch(error => {

        console.log(JSON.stringify(error.response.data.message))        
        if (error.response.status == '403'){
          this.$router.push({ path: '/auth'})
        }

        // Here we could override the busy state, setting isBusy to false
        console.log(JSON.stringify(error.response.status))        



        if (error.response.data.error){
          console.log(error.response.data.error)
          console.log("error.response.data.error")
        } else if (error.message){
          console.log(error.message)
          console.log("error.message")
        } else {
          console.log(JSON.stringify(error))        
          console.log("error")
        }

        this.items=[]
        this.isBusy = false
        this.totalRows = this.items.length
      })               
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  }
}
</script>